import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';
import { Button, Breadcrumb } from 'semantic-ui-react';
import { Text } from '@tcaster/tcaster-web-lib';
import { COLOR, FONT_SIZE } from '@tcaster/tcaster-theme';

import NavButton from '../../Components/CloseButton';
import TCIcon from '../../Components/TCIcon';

const Divider = Breadcrumb.Divider;
const Section = Breadcrumb.Section;

export const NavHeader = ({ current, total, title }) => (
  <Fragment>
    <Flex justifyContent="space-between">
      <Box>
        <Text fontSize={FONT_SIZE.large} fontWeight={500}>
          {title}
        </Text>
      </Box>
      <Box />
    </Flex>
    <Box pt={2}>
      <StepsDiv current={current} total={total} />
    </Box>
  </Fragment>
);

export const NavBar = ({ onBackClick, enableBack, showClose, onClose }) => (
  <Flex justifyContent="space-between" width={1} pb={3}>
    <Box>
      <NavButton
        onClick={onBackClick}
        disabled={!enableBack}
        content={
          <span style={{ fontWeight: 400 }}>
            <TCIcon name="previous" />
            กลับ
          </span>
        }
      />
    </Box>
    <Box>{showClose && <NavButton onClick={onClose} />}</Box>
  </Flex>
);

export const StepsDiv = ({ current, total }) => {
  return (
    <Flex style={{ height: 2, width: '100%' }}>
      {Array(total)
        .fill(0)
        .map((x, i) => {
          return (
            <Box key={i} width={1 / total}>
              <Box
                style={{ backgroundColor: i <= current ? COLOR.primary : COLOR.greyscale.grey2 }}
                py={'2px'}
                mr={i === 0 ? 2 : i !== 0 && i !== total - 1 ? 2 : 0}
                ml={i === total - 1 ? 2 : i !== 0 && i !== total - 1 ? 2 : 0}
              />
            </Box>
          );
        })}
    </Flex>
  );
};

export const Steps = ({ steps }) => (
  <Box mt={0}>
    <Breadcrumb>
      {steps.map((step, index) => {
        if (step !== null && step.length > 0) {
          return (
            <Fragment key={index}>
              <Section active={index === steps.length - 1}>
                <Text fontWeight="300">{step}</Text>
              </Section>
              {index !== steps.length - 1 && <Divider icon="right chevron" />}
            </Fragment>
          );
        }
      })}
    </Breadcrumb>
  </Box>
);

export const renderHeader = (steps, unitText) => data => (
  <Flex justifyContent="space-between" alignItems="baseline" mt={1}>
    <Box>
      <Steps steps={steps} />
    </Box>
    <Box>
      {unitText && (
        <Text fontWeight="300">
          พบ {data.length} {unitText}
        </Text>
      )}
    </Box>
  </Flex>
);

Steps.defaultProps = {
  steps: [],
};
